export default "__VITE_ASSET__DnPddCSM__"